import React from 'react';

import DefaultTemplate from 'src/templates/default';
import PageHeader from 'src/components/headers/page-header';
import { SupportingText } from 'src/components/Layout/SupportingText';
import { IntroSection } from 'src/components/Layout/IntroSection';
import { Carousel, SimpleSlide } from 'src/components/Carousel';
import FooterExtension from 'src/components/footer-extension';

import { CmsThemes, Locales } from 'src/lib/constants';
import { dangerous_getStaticData } from 'src/lib/getStaticData';

const AccountFunding = ({ locale = Locales.EN_GB }) => {
  const {
    metaData,
    pageHeaderData,
    introSectionData,
    supportingTextData,
    simpleCarouselData,
    footerExtensionData,
  } = dangerous_getStaticData({
    locale,
    filePath: 'solutions/account-funding',
  });
  return (
    <DefaultTemplate {...metaData} locale={locale} cmsTheme={CmsThemes.WEB3}>
      <PageHeader {...pageHeaderData} />
      <IntroSection {...introSectionData} />
      <SupportingText {...supportingTextData} />
      <Carousel>
        {simpleCarouselData['carousel-slides'].map((slide) => {
          return (
            <SimpleSlide
              carouselTitle={simpleCarouselData['carousel-title']}
              {...slide}
            />
          );
        })}
      </Carousel>
      <FooterExtension {...footerExtensionData} />
    </DefaultTemplate>
  );
};

export default AccountFunding;
